import { colors, font_variant_styles } from '@akin-home/theme';
import { TextInput } from 'react-native';
import styled from 'styled-components/native';

/**
 * For your text input displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
// eslint-disable-next-line react/display-name
// export const LargeInput = forwardRef<TextInput, TextInputProps>(
//   (props, ref) => {
//     const { style, ...rest } = props;

//     return (

//           <Input
//             {...rest}
//             ref={ref}
//             style={style}
//           />
//         )}

//     );
//   }
// );

export const LargeInput = styled(TextInput)`
  ${font_variant_styles.h2.semibold};
  color: ${colors.text.input};
  height: 76px;
  border-radius: 15px;
  background-color: ${colors.blue.input_background};
  padding: 18px 24px;

  flex: 1;
`;
